import { ORDERED_CHANNEL_KEYS, CHANNEL_MAPPING } from 'constants/channels';
import { reduce, sortBy, set, get } from 'lodash';
import memoize from 'fast-memoize';

exports.validChannels = ORDERED_CHANNEL_KEYS.map(channel => CHANNEL_MAPPING[channel]);

exports.supportedChannels = exports.validChannels.filter(e => e.supported);

exports.supportedChannelNamesList = exports.supportedChannels.map(k => k.key);

exports.supportedChannelDisplayNamesList = exports.supportedChannels.map(k => k.displayName);

exports.supportedChannelDisplayNamesKeyed = exports.supportedChannels.reduce((acc, channel) => {
    acc[channel.key] = channel.displayName;
    return acc;
}, {});

const diplayNameToKeyLookup = exports.supportedChannels.reduce(
    (prev, cfg) => set(prev, [cfg.displayName], cfg.key), {}
);

exports.displayNameToKey = memoize(displayName => get(diplayNameToKeyLookup, [displayName]));

exports.getChannelDeliveryPlatforms = memoize(
    (channelKey, scope) => {
        if (exports.channelHasMultiplePlatforms(channelKey)) {
            const channelPlatforms = Object.entries(CHANNEL_MAPPING[channelKey].deliveryPlatforms);

            return channelPlatforms.reduce((allowedPlatforms, currentPlatform) => {
                const platformDetails = currentPlatform[1];
                const platformCapability = platformDetails.capability;

                if (!platformCapability || (scope && scope.includes(platformCapability))) {
                    allowedPlatforms[currentPlatform[0]] = platformDetails;
                }

                return allowedPlatforms;
            }, {});
        }

        return null;
    }
);

exports.channelHasMultiplePlatforms = memoize(
    (channelKey) => {
        const platforms = get(CHANNEL_MAPPING, [channelKey, 'deliveryPlatforms']);
        return platforms && Object.keys(platforms).length > 1;
    }
);

exports.isPlatformInChannel = memoize(
    (channel, platform) =>
        Object.keys(get(CHANNEL_MAPPING, [channel, 'deliveryPlatforms'], {})).includes(platform)
);

exports.getDefaultDeliveryPlatform = memoize((adminPlatform, channel) => CHANNEL_MAPPING[channel][adminPlatform]);

exports.configurableChannelsByPlatform = entityPlatform => exports.supportedChannels.filter(
    channel => exports.channelHasMultiplePlatforms(channel.key) && channel[entityPlatform]
);

exports.getDefaultChannelDataSources = entityPlatform => exports.configurableChannelsByPlatform(entityPlatform).reduce(
    (prev, config) => {
        prev[config.key] = config[entityPlatform];
        return prev;
    }, {});

exports.getDefaultEnabledChannels = () => reduce(CHANNEL_MAPPING, (res, val, key) => {
    res[key] = { enabled: val.defaultEnabledState };
    return res;
}, {});

exports.getSortedChannelsDataSourceConfig = entityPlatform => sortBy(exports.configurableChannelsByPlatform(entityPlatform), ['displayName']).reduce((acc, config) => {
    acc.push({
        channel: config.key,
        default: config[entityPlatform]
    });
    return acc;
}, []);

exports.getRequiredCapabilities = channel => get(CHANNEL_MAPPING, [channel, 'requiredCapabilities'], []);



// WEBPACK FOOTER //
// ./src/helpers/channels.js